/*
 * Purpose: Tenant-scoped localStorage keys — P5/P6 multitenancy
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { getActiveTenantId } from '@/lib/auth-session';
import { tenantStoragePrefix } from '@/lib/auth-tenants';

const LEGACY_WORKFLOWS_KEY = 'workflows';
const LEGACY_VAULT_KEY = 'autoblocks.vault.v1';
const LEGACY_CONNECTORS_KEY = 'autoblocks_connector_library';
const LEGACY_SETUP_COMPLETE = 'autoblocks.setup.completedAt';

export function resolveTenantId(): string {
  return getActiveTenantId() || 'local';
}

export function tenantStorageKey(suffix: string): string {
  return `${tenantStoragePrefix(resolveTenantId())}${suffix}`;
}

export function workflowsStorageKey(): string {
  return tenantStorageKey('workflows');
}

export function logsStorageKey(): string {
  return tenantStorageKey('execution_logs');
}

export function vaultStorageKey(): string {
  return tenantStorageKey('vault.v1');
}

export function connectorsStorageKey(): string {
  return tenantStorageKey('connector_library');
}

export function setupCompleteStorageKey(): string {
  return tenantStorageKey('setup.completedAt');
}

function migrateLegacyKey(tenantKey: string, legacyKey: string): void {
  if (typeof window === 'undefined') return;
  if (localStorage.getItem(tenantKey)) return;
  const legacy = localStorage.getItem(legacyKey);
  if (!legacy) return;
  localStorage.setItem(tenantKey, legacy);
}

/** One-time migration from global keys to tenant-scoped keys. */
export function migrateLegacyTenantStorageIfNeeded(): void {
  migrateLegacyKey(workflowsStorageKey(), LEGACY_WORKFLOWS_KEY);
  migrateLegacyKey(vaultStorageKey(), LEGACY_VAULT_KEY);
  migrateLegacyKey(connectorsStorageKey(), LEGACY_CONNECTORS_KEY);
  migrateLegacyKey(setupCompleteStorageKey(), LEGACY_SETUP_COMPLETE);
}

/** @deprecated Use migrateLegacyTenantStorageIfNeeded */
export function migrateLegacyWorkflowsIfNeeded(): void {
  migrateLegacyTenantStorageIfNeeded();
}
